import { LatLng, LatLngLiteral } from "leaflet";

export const extractCoordinatesFromGeoJSON = (
  geoJSON: any
): LatLngLiteral[][] => {
  if (!geoJSON) return [];

  const features =
    geoJSON.type === "FeatureCollection" ? geoJSON.features : [geoJSON];

  const coordinates: LatLngLiteral[][] = [];

  features.forEach((feature: any) => {
    if (feature.geometry && feature.geometry.type === "Polygon") {
      feature.geometry.coordinates.forEach((ring: number[][]) => {
        const ringCoordinates: LatLngLiteral[] = ring.map(([lng, lat]) => ({
          lat,
          lng,
        }));
        coordinates.push(ringCoordinates);
      });
    }
  });

  return coordinates;
};
